import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type Form } from "./types";

export default {
  get: (apiInfo: ModuleApiInfo, formId: string): Promise<HttpApiResponse<Form.Api.GetResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/form/${formId}`),
  progress: (
    apiInfo: ModuleApiInfo,
    formId: string,
    pageId: string,
    data: Form.Api.ProgressRequest
  ): Promise<HttpApiResponse<Form.Api.ProgressResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/form/${formId}/pages/${pageId}`, data)
};
